<template>
    <footer class="pt-6 w-full bg-primary-emphasis bg-opacity-60">
        <div class="flex flex-col sm:flex-row sm:items-start justify-around">
            <div class="">
                <div class="flex flex-col items-center">
                    <strong
                        class="text-lg text-primary-emphasis dark:text-white"
                    >
                        {{ $t("footer.social") }}
                    </strong>
                    <div class="flex justify-center my-1">
                        <a
                            href="https://www.linkedin.com/in/nicolas-david-pastran-zamora/"
                            target="_blank"
                            rel="noopener"
                            aria-label="Instagram page"
                        >
                            <linked-in-icon
                                class="icon w-8 h-8 text-primary-secondary"
                            />
                        </a>
                    </div>
                </div>
            </div>
            <div class="">
                <div class="flex flex-col items-center">
                    <strong
                        class="text-lg text-primary-emphasis dark:text-white"
                    >
                        {{ $t("footer.author") }}
                    </strong>
                    <div class="">
                        <a
                            href="https://www.softool.co"
                            target="_blank"
                            rel="noopener"
                            aria-label="Softool page"
                            class="mr-1 flex items-center my-2"
                        >
                            <img
                                class="h-6 sm:h-8 lg:h-10"
                                src="/img/logo.png"
                                :alt="`Logo ${$siteTitle}`"
                                loading="lazy"
                            />
                            <span class="text-primary-secondary">
                                Softool | Nicolas Pastran
                            </span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="">
                <div class="flex flex-col items-center sm:items-start">
                    <div class="flex justify-center">
                        <strong
                            class="text-lg text-primary-emphasis dark:text-white"
                        >
                            {{ $t("footer.otherTools") }}
                        </strong>
                    </div>

                    <a
                        aria-label="Posix Converter"
                        href="https://posix.softool.co"
                        target="_blank"
                        rel="noopener"
                        class="no-underline hover:underline text-primary-secondary hover:text-black"
                    >
                        {{ $t("footer.posixConverter") }}
                    </a>
                    <a
                        aria-label="JSON Tools"
                        href="https://json.softool.co"
                        target="_blank"
                        rel="noopener"
                        class="no-underline hover:underline text-primary-secondary hover:text-black"
                    >
                        {{ $t("footer.jsonTools") }}
                    </a>
                    <a
                        aria-label="Text Tools"
                        href="https://textcases.softool.co"
                        target="_blank"
                        rel="noopener"
                        class="no-underline hover:underline text-primary-secondary hover:text-black"
                    >
                        {{ $t("footer.textTools") }}
                    </a>
                </div>
            </div>
        </div>
        <div class="mx-auto px-6 mt-4">
            <div
                class="border-t-2 border-primary-emphasis flex flex-col items-center"
            >
                <div
                    class="sm:w-2/3 flex flex-col items-center justify-center py-6"
                >
                    <p
                        class="text-sm text-primary-emphasis dark:text-white font-bold"
                    >
                        © {{ new Date().getFullYear() }}

                        <a href="/" class="no-underline hover:underline">
                            JSON Tools
                        </a>
                        <span class="font-normal opacity-70">
                            v{{ version }}
                        </span>
                    </p>
                    <span>💛💙❤️</span>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
import LinkedInIcon from "@/components/icons/Linkedin.vue";

import { version } from "../../../package.json";

export default {
    name: "FooterMain",
    components: { LinkedInIcon },
    data: () => ({ version }),
    methods: {}
};
</script>
